import { render, staticRenderFns } from "./TerritorialUnitAllocationListTable.vue?vue&type=template&id=88a5c598&"
import script from "./TerritorialUnitAllocationListTable.vue?vue&type=script&lang=js&"
export * from "./TerritorialUnitAllocationListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports